import _ from 'lodash';

import { FindAndReplace } from '../../types';
import replaceMetricInChart from './replaceMetricInChart';

// Several report gadgets can share a chartDef id (a legacy of the
// self-contained report gadgets migration), so every match is considered and
// only the ones that actually change are returned.
const getReportGadgetReplacements = ({
  allGadgets,
  chartDefinitionIds,
  findMetricId,
  replaceMetricId,
}: {
  allGadgets: FindAndReplace.PersistedReportGadget[];
  chartDefinitionIds: string[];
  findMetricId: string;
  replaceMetricId: string;
}): { reportGadgetId: string; updatedChartDef: VisualisationDefinition }[] =>
  allGadgets.flatMap((gadget) => {
    const { chartDef } = gadget;
    if (!chartDef || !chartDefinitionIds.includes(chartDef.id)) {
      return [];
    }

    const updatedChartDef = replaceMetricInChart(
      findMetricId,
      replaceMetricId,
      chartDef,
    );
    if (_.isEqual(updatedChartDef, chartDef)) {
      return [];
    }

    return [{ reportGadgetId: gadget.id, updatedChartDef }];
  });

export default getReportGadgetReplacements;
